module.exports = __webpack_public_path__ + "ProximaNova-Bold.926a08f.ttf";